<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerRight from '../components/oferta/TopBannerRight.vue'
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue';
const DocPlanEstudios = defineAsyncComponent(() => import('../components/oferta/DocPlanEstudios.vue'));
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue')) ; 
    const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue')) 
    const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    // const DocExcelenciaAcadem = defineAsyncComponent(() => import('../components/oferta/DocExcelenciaAcadem.vue')) ; 
</script>

<template>
    <TopBannerRight
        :img="'background-image: url(../../pagesImages/doctorado-derecho-humanitas.jpg);'"
        :nivel="'Doctorado en'"
        :carrera="'Derecho'"
        :frase="'La justicia sin fuerza es impotente, la fuerza sin la justicia es tiránica'"
        :autor="'Blaise Pascal'"
    />

    <FormarBloque
        :img="'../../pagesImages/estudiante-modelo-ejecutivo-universidad-humanitas.jpg'"
        :link="'/requisitos-doctorado'"
        alt="Hombre con doctorado en Universidad Humanitas"
        :frase="'Profundiza en el marco normativo y los sistemas legales. Genera conocimiento desde la excelencia jurídica'"
        :testo1="'Se enfoca en el dominio e interpretación del marco normativo mexicano, el desarrollo de habilidades argumentativas y la aplicación de metodologías de investigación en proyectos tanto jurídicos como educativos.'"
        :testo2="'En el área de investigación, el doctorado promueve el análisis y desarrollo de temas jurídicos de actualidad, con el fin de responder a las crecientes demandas en materia de resolución de conflictos, optimización de procesos legales y administración de justicia.'"
        :testo3="'Aquellos profesionales que cuenten con un título de licenciatura y maestría en Derecho, además de tener experiencia en el ejercicio de su profesión, la docencia o la investigación con rigor metodológico. Poseer también conocimientos sólidos en teoría del Derecho, argumentación jurídica y normatividad.'"
    />

    <div class="flex items-center justify-center my-10">
    </div>

    <DocPlanEstudios
        :ejecutivo="true"
    />

    <VerModelo esco=""
    ejec="/pagesImages/doctorado-derecho-plan-de-estudios.webp"
    virt=""
    :escoT="false"
    :ejecT="true"
    :virtT="false" />

    <CalendarioOferta nombre="Doctorado en Derecho" :titulo="'Calendario del doctorado'" :subtitulo="'Conoce el programa de doctorado que consolidará.'"
  :inicios="[true, false, false, false, true, false, false, false]"></CalendarioOferta>

    <!-- <DocExcelenciaAcadem class="mb-16" />

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Metodología</span>
                        </h2>
                        <p class="mb-4">
                            El modelo ejecutivo se desarrolla bajo la siguiente estructura:
                        </p>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Consta de 6 bloques semestrales.</li>
                            <li>Cada bloque equivale a tres materias fusionadas, impartidas por un especialista en la materia.</li>
                            <li>Se imparten clases un día a la semana, tres horas de clases presenciales.</li>
                            <li>El modelo educativo tiene una duración de diez semanas de clases, y una semana adicional culminando con una evaluación final.</li>
                            <li>La evaluación se compone de participación en clase, foros, trabajos y examen final, integrando así un proceso de aprendizaje integral.</li>
                        </ul>
                        <p>
                            Este modelo permite a los estudiantes desarrollar habilidades especializadas con un enfoque práctico y estratégico, alineado con las exigencias del mundo profesional actual.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/universidad-fisica-virtual.webp" alt="Estudiantes de maestría en alta dirección corporativa universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section> -->

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques semestrales):</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li><b>Fundamentos jurídicos e investigación inicial:</b> Historia del Derecho mexicano, argumentación jurídica y seminario de investigación I.</li>
                            <li><b>Teoría jurídica y desarrollo del litigio:</b> Evolución doctrinal y práctica legal, evolución del pensamiento jurídico, teoría general de la composición del litigio y seminario de investigación II.</li>
                            <li><b>Marco normativo y justicia:</b> Profundización en el sistema jurídico mexicano, conocimiento integral del marco normativo mexicano, administración de justicia y seminario de tesis doctoral I.</li>
                            <li><b>Derechos Humanos y docencia jurídica:</b> Perspectivas contemporáneas y formación académica, enseñanza del Derecho, sistema mexicano e interamericano de Derechos Humanos y seminario de tesis doctoral II.</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/estructura-academica-doctorados.webp" alt="Alt pendiente" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>

    <section class="lg:flex items-center justify-center bg-cover bg-[center] bg-no-repeat mb-16" style="background-image: url(/pagesImages/madin3.jpg); position: relative; background-attachment: fixed; background-position: left; background-repeat: no-repeat; background-size: cover; overflow: hidden; transition: transform 0.3s ease;">
        <div class="lg:flex items-center justify-center w-full h-full my-16">
            <div class="lg:flex items-center justify-between w-full max-w-[1200px]">
                <img src="/pagesImages/graduado-doctorado.webp" alt="Ejecutivo con doctorado en Derecho Universidad Humanitas" class="lg:p-0 w-full lg:max-w-[520px] md:px-16 px-6 pt-6"/>
                <div class="flex flex-col lg:justify-start justify-center items-center lg:items-start lg:w-[50%] w-full lg:my-24 py-12 text-justify md:px-0  px-12">
                    <h2>
                        <span class="block text-[28px] text-hwine leading-none text-center md:text-left">Perfil del egresado de</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hwine text-[42px] mb-4 leading-tight text-center md:text-left font-serif ">Doctorado en Derecho</span>
                    </h2>
                    <p class="text-justify text-gray-800 hyphens-auto">Profesional con sólida trayectoria académica en Derecho, habilidades de investigación desarrolladas, capacidad de pensamiento crítico, dominio de la comunicación académica y una propuesta de investigación prometedora. Son líderes e investigadores que contribuyen significativamente al desarrollo del Derecho en México y a nivel internacional.</p>
                    <br>
                    <router-link to="/contacto">
                        <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white  text-lg transition duration-300 ease-in-out">
                            <span>Inscr&iacute;bete</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>
    <PoliticaIA />
</template>

<style scoped>
</style>